/**
 * Sentiment buckets, shared by every dashboard that reports customer mood.
 *
 * Scores run 1–10. The bounds are inclusive upper limits, matching the shape the email
 * analytics config has always used, so «negative» means the same thing on every page.
 */

export const SENTIMENT_THRESHOLDS = { negativeMax: 3, neutralMax: 6 } as const

export const SENTIMENT_BUCKETS = ["negative", "neutral", "positive"] as const

export type SentimentBucket = (typeof SENTIMENT_BUCKETS)[number]
